import { render } from "./AppBody.vue?vue&type=template&id=a0d677a8&scoped=true"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"

import "./AppBody.vue?vue&type=style&index=0&id=a0d677a8&scoped=true&lang=css"
import "./AppBody.vue?vue&type=style&index=1&id=a0d677a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d677a8"]])

export default __exports__